export default "<div #diagramDiv style=\"border: solid 1px blue; width:400px; height:150px\"></div>\r\n"